import { useMemo } from 'react'
import styled from 'styled-components'

import { AppDataTable } from '@root/features/app-data-table/app-data-table'

import { reatomBackOfficeUsersSearch } from '../atoms/reatom-back-office-users-search-table'

import type { BackOfficeUser } from '@root/entities/back-office'

export const BackOfficeUsersTable = () => {
  const model = useMemo(
    // eslint-disable-next-line @reatom/unit-naming-rule
    () => reatomBackOfficeUsersSearch(),
    [],
  )

  return <Root model={model.tableModel} rowHeight={40} />
}

const Root = styled(AppDataTable<BackOfficeUser.BackOfficeUser>)`
  height: 100%;
`
